function injectMetaPixelIfProduction() {
    // Require both production build and an explicit opt-in variable
    // This avoids sending PageView in homolog/testing builds even if NODE_ENV=production
    if (process.env.NODE_ENV !== 'production') return;
    if (process.env.REACT_APP_ENABLE_PIXEL !== 'true') return;

    try {
        const script = document.createElement('script');
        script.type = 'text/javascript';
        script.innerHTML = `!function(f,b,e,v,n,t,s)
    {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
    n.callMethod.apply(n,arguments):n.queue.push(arguments)};
    if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
    n.queue=[];t=b.createElement(e);t.async=!0;t.src=v;s=b.getElementsByTagName(e)[0];
    s.parentNode.insertBefore(t,s)}(window, document,'script',
    'https://connect.facebook.net/en_US/fbevents.js');
    fbq('init', '1148573897439751');
    fbq('track', 'PageView');`;
        document.head.appendChild(script);

        const noscript = document.createElement('noscript');
        noscript.innerHTML = `<img height="1" width="1" style="display:none" src="https://www.facebook.com/tr?id=1148573897439751&ev=PageView&noscript=1"/>`;
        document.body.appendChild(noscript);
    } catch (e) {
        // falhar silenciosamente para não interromper a aplicação
        // eslint-disable-next-line no-console
        console.error('Erro ao injetar Meta Pixel', e);
    }
}

function trackFacebookEvent({
  event = 'Contact',
  isCustom = false,
  content_name = '',
  channel = '',
  page = window.location.pathname,
  ...customData
} = {}) {
  if (!window.fbq) return;

  const payload = {
    ...(content_name && { content_name }),
    ...(channel && { channel }),
    ...(page && { page }),
    ...customData
  };

  if (isCustom) {
    window.fbq('trackCustom', event, payload);
  } else {
    window.fbq('track', event, payload);
  }
}


export { injectMetaPixelIfProduction, trackFacebookEvent };
